export function toMinutes(time: string): number {
    const match = time.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
    if (!match) {
        throw new Error('Invalid time format. Expected format: "HH:MM AM/PM"');
    }

    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    const meridian = match[3].toUpperCase();

    if (meridian === 'PM' && hours !== 12) {
        hours += 12;
    } else if (meridian === 'AM' && hours === 12) {
        hours = 0;
    }

    // Validaciones adicionales
    if (hours < 0 || hours > 23) {
        throw new Error('Invalid hour value');
    }
    if (minutes < 0 || minutes > 59) {
        throw new Error('Invalid minutes value');
    }

    return hours * 60 + minutes;
}

export function sortSessionTimes<T extends { hour: string; id: number }>(
    sessions: T[]
): T[] {
    return [...sessions].sort((a, b) => toMinutes(a.hour) - toMinutes(b.hour));
}
